import { AdminSettings } from "@/components/admin-settings";
import { usePageTitle } from "@shared/client/view";
import { AdminMeta } from "@shared/components/blocks";

export default function AdminSettingsPage() {
  usePageTitle("Agent & modèle — Administration Hune");
  return (
    <>
      <AdminMeta>Configuration technique de l’agent — les clés DeepSeek et OpenAI restent des secrets du serveur</AdminMeta>
      <AdminSettings />
    </>
  );
}
